export enum CacheKeyEnum {
  dataMhubPackage = "dataMhubPackage",
  simMhubPackage = "simMhubPackage",
  travelMhubPackage = "travelMhubPackage",
  mhubStoreList = "mhubStoreList",
  mhubServiceList = "mhubServiceList",
  mhubNumberTypeList = "mhubNumberTypeList",
  language = "mhub-language",
  mainToken = "m-token",
  alterToken = "m-alter-token",
}
